<template>
  <v-container fluid class="pa-0 d-flex justify-center">
    <v-card class="border-thin mt-5" elevation="0" style="width: 800px">
      <!-- Header -->
      <v-card-title class="cardTitle pa-0 pr-4">
        <v-card-actions>
          <v-icon icon="mdi-file-chart-outline" class="ma-2" size="24" />
          <div class="cardTitle">Export analytics</div>
        </v-card-actions>
      </v-card-title>

      <v-card-text class="border-t-thin pa-4">
        <v-select
          v-model="selectedPeriod"
          return-object
          density="compact"
          variant="outlined"
          rounded="0"
          prepend-icon="mdi-calendar-range"
          :items="timepoints"
          label="Select time period"
        >
        </v-select>

        <v-autocomplete
          v-model="selectedEvents"
          density="compact"
          variant="outlined"
          rounded="0"
          prepend-icon="mdi-filter"
          label="Select events"
          :items="availableEvents"
          no-data-text="No events available"
          chips
          multiple
        >
          <template #prepend-item>
            <v-list-item class="pa-0" @click.stop="handleToggleAll">
              <v-checkbox
                :model-value="selectedEvents.length === availableEvents.length"
                label="Select all"
                class="ma-0 pa-0"
                hide-details
              />
            </v-list-item>
          </template>
        </v-autocomplete>

        <v-card-actions class="pa-0">
          <v-spacer />
          <v-btn
            :disabled="!selectedPeriod || !selectedEvents.length"
            :loading="generatingExport"
            @click.prevent="generateExport"
            color="success"
            rounded="0"
            variant="elevated"
            >generate export
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>

    <DateRangePicker
      v-model:dialogProp="pickDateRange"
      @setRange="setCustomTimeRange"
      allow-days
    />
  </v-container>
</template>
<script>
import DateRangePicker from "@/components/DateRangePicker.vue";

export default {
  name: "LIAnalytics",
  components: {
    DateRangePicker,
  },
  data: () => {
    return {
      timepoints: [],
      selectedPeriod: null,
      selectedEvents: [],
      availableEvents: [],
      generatingExport: false,
      pickDateRange: false,
    };
  },
  mounted() {
    this.getExportDetails();

    this.setUpAvailableTimepoints();
  },
  methods: {
    getExportDetails() {
      // Fetch export details from the API
      this.$axios
        .get("/details-export-analytics")
        .then((response) => {
          this.availableEvents = response.data.events;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    setUpAvailableTimepoints() {
      const now = new Date();
      const last = new Date(now.getFullYear(), now.getMonth() - 1);

      const currentMonth = now.toLocaleString("default", {
        month: "long",
        year: "numeric",
      });

      const lastMonth = last.toLocaleString("default", {
        month: "long",
        year: "numeric",
      });

      this.timepoints = [
        { title: currentMonth, value: "currentMonth" },
        { title: lastMonth, value: "lastMonth" },
        { title: "Last 3 months", value: "last3months" },
        { title: "All time", value: "allTime" },
        { title: "Date range", value: "custom" },
      ];
    },
    generateExport() {
      this.generatingExport = true;
      this.$axios
        .post(
          "/export-analytics",
          {
            period: this.selectedPeriod.value,
            events: this.selectedEvents,
          },
          {
            responseType: "blob", // tell Axios to give you raw bytes
          },
        )
        .then((response) => {
          let filename = "export.csv";
          const disposition = response.headers["content-disposition"];
          if (disposition) {
            const match = disposition.match(
              /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
            );
            if (match) filename = match[1].replace(/['"]/g, "");
          }

          // 1) wrap the binary in a Blob
          const blob = new Blob([response.data], { type: "text/csv" });
          // 2) create an object URL
          const url = window.URL.createObjectURL(blob);
          // 3) trigger the download
          const a = document.createElement("a");
          a.href = url;
          a.download = filename; // use parsed filename or fallback
          document.body.appendChild(a);
          a.click();
          // 4) cleanup
          a.remove();
          window.URL.revokeObjectURL(url);

          // clear fields
          this.selectedPeriod = null;
          this.selectedEvents = [];
        })
        .catch((error) => {
          console.error("Error generating export:", error);
        })
        .finally(() => {
          this.generatingExport = false;
        });
    },
    handleToggleAll() {
      if (this.selectedEvents.length === this.availableEvents.length) {
        this.selectedEvents = [];
      } else {
        this.selectedEvents = [...this.availableEvents];
      }
    },
    setCustomTimeRange(range) {
      // push to the list if it doesn't exist
      range = { title: range.label, value: range.dateSelection };

      if (
        !this.timepoints.some((timepoint) => timepoint.dateSelection === range)
      ) {
        this.timepoints.push(range);
      }

      // set the selected timepoint
      this.selectedPeriod = range;
      this.pickDateRange = false;
    },
  },
  watch: {
    selectedPeriod: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          if (newVal.value === "custom") {
            // open date picker
            this.pickDateRange = !this.pickDateRange;

            this.selectedPeriod = null;
          }
        }
      },
    },
  },
};
</script>
<style scoped></style>
